$( document ).ready(function() {

    var getHeights = function () {
//    var stick_height = $(".stickaroo").innerHeight();
//    var annc_height = $("#shopify-section-announcement-bar").innerHeight();
//    var last_height = $("#shopify-section-header").innerHeight();

      var header_height = $("header.header").innerHeight();

      stick_height = header_height; // add height of menu header
  
	//$(".rest_of_content").css("margin-top", stick_height + "px")
    console.log('height: ' + stick_height);
  }

  $(window).bind('resizeEnd', function() {
    //do something, window hasn't changed size in 500ms
    getHeights();
  });

  $(window).on('resize', function(){
    if(this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function() {
        $(this).trigger('resizeEnd');
    }, 500);
  });
  
  getHeights();






  function aboutSticky() {
    
    var stickyTop = $('.div_00').offset().top;
  
  	if ($(window).width() > 1024) {

      var top_container_height = $('.div_00').innerHeight();
  	  
  	  $(window).scroll(function() {
  
  	  	//console.log("here: " + stickyTop);
  	    var windowTop = $(window).scrollTop();
  
  	    var diff = stickyTop - windowTop;
  	    //console.log("diff: " + diff);
  	    if(diff < 63) {
    	    console.log('sticking it! ');
    	      $('.div_00').addClass('about_stickaroo');
    	      $('.rest_of_content').css('margin-top', top_container_height + 'px');
  	    } else {
          console.log('unsticking it.');
  	      $('.div_00').removeClass('about_stickaroo');
  	      $('.rest_of_content').css('margin-top','0px');
  	    }
  	  });

  	}
  }
  
  setTimeout(function() {
        aboutSticky()
  }, 500);


});